import { MutationTree } from 'vuex'
import { ProfileState, UserData } from './types'
import { UserInfo } from 'firebase'

export const mutations: MutationTree<ProfileState> = {
  setUser (state, payload: UserInfo) {
    state.user = payload
  },
  updateUserData (state, payload: UserData) {
    state.data = payload
  },
  setOpenAuth (state, payload: boolean) {
    state.openAuth = payload
  },
  setTo (state, payload: string) {
    state.to = payload
  }
}
